module.exports = __webpack_public_path__ + "cool-B8AKO9O.svg";